import { useRef } from 'react';

import { useLegalClientSaveInvestmentPurposeAndNature } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { InvestmentPurposeAndNatureFormType } from '../forms/investmentPurposeAndNatureForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/investmentPurposeAndNature';

import { useOnboardingContext } from './useOnboardingContext';

export const useInvestmentPurposeAndNature = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { t } = useTranslation();

  const {
    loading: submitLoading,
    saveInvestmentPurposeAndNature,
    error,
  } = useLegalClientSaveInvestmentPurposeAndNature();

  const initialValues: InvestmentPurposeAndNatureFormType | undefined = useRef(
    getInitialData(t, data.legalClient?.investmentPurposeAndNature)
  ).current;

  const onSubmit = async (values: InvestmentPurposeAndNatureFormType) => {
    const submitData = getSubmitData(values);
    await saveInvestmentPurposeAndNature(data.legalClient!.id, submitData);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    submitLoading,
    initialValues,
  };
};
